export default __webpack_public_path__ + "static/media/flayer5.039da521.jpg";